module.exports = __webpack_public_path__ + "static/img/20250416.4d16464.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20231122/20250416.png
// module id = Zkhq
// module chunks = 7